import { render } from "./OnboardingGearUpReview.vue?vue&type=template&id=6104090b&scoped=true"
import script from "./OnboardingGearUpReview.vue?vue&type=script&lang=js"
export * from "./OnboardingGearUpReview.vue?vue&type=script&lang=js"

import "./OnboardingGearUpReview.vue?vue&type=style&index=0&id=6104090b&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6104090b"]])

export default __exports__